<template>
        <v-row align="center">
            <v-col cols="12" class="text-center pt-6">
                <p class="subtitle-1">Please enter your <b>account number</b>, <b>invoice number</b> and the <b>amount to pay</b>. You can find these on your Breeze Connect bill.</p>
            </v-col>
            <v-col cols="12" md="6">
                <v-img
                        :src="require('@/assets/billimage.png')"
                        style="border: solid 1px black;"
                        alt="Breeze Connect Invoice"
                        contain
                />
            </v-col>
            <v-col cols="12" md="6" align="center">
                <v-form name="accountDetail" v-model="formValid">
                    <v-text-field
                        v-model="invoiceNumber"
                        label="Invoice Number"
                        name="invoice"
                        type="text"
                        @input="change"
                        outlined
                        :rules="[v => !!v || 'Invoice number is required', v => /^\d{2,6}$/.test(v) || 'Invalid invoice number entered']"
                        required
                    />
                    <v-text-field
                        v-model="accountNumber"
                        label="Account Number"
                        name="account"
                        type="text"
                        @input="change"
                        outlined
                        :rules="[v => !!v || 'Account number is required', v => /^\d{1,6}$/.test(v) || 'Invalid account number entered']"
                        required
                    />
                    <v-text-field
                            v-model="paymentAmount"
                            prefix="$"
                            label="Amount to Pay"
                            name="amount"
                            type="text"
                            @input="change"
                            outlined
                            :rules="[v => !!v || 'Amount to Pay is required', v => /^\d+(.\d{2})?$/.test(v) || 'Invalid payment amount entered']"
                            required
                    />
                </v-form>
            </v-col>
        </v-row>
</template>

<script>
    export default {
        name: "AccountInvoiceDetail",
        data() {
            return {
                invoiceNumber: null,
                accountNumber: null,
                paymentAmount: null,
                formValid: false
            };
        },
        watch: {
            'formValid': function(val) {
                if (val) {
                    this.$emit('valid', {
                        'invoice': this.invoiceNumber,
                        'account': this.accountNumber,
                        'paymentAmount': this.paymentAmount
                    });
                } else {
                    this.$emit('invalid');
                }
            }
        },
        methods: {
            change() {
                if (this.formValid) {
                    this.$emit('valid', {
                        'invoice': this.invoiceNumber,
                        'account': this.accountNumber,
                        'paymentAmount': this.paymentAmount
                    });
                }
            }
        },
        props: {
            invoice: {
                type: Number,
                default: null
            },
            account: {
                type: Number,
                default: null
            },
            amount: {
                type: String,
                default: null
            }

        },
        created() {
            this.invoiceNumber = this.invoice;
            this.accountNumber = this.account;
            this.paymentAmount = this.amount;
        }
    }
</script>